var _g, _circle, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter0_f_385_634)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 4.5,
    fill: "#6E74FF"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 9,
    transform: "rotate(-180 15 15)",
    fill: "#E9E9FD"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_385_634)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1832 10.796C16.4723 10.9183 16.7336 11.0982 16.951 11.3247C17.1462 11.5208 17.2965 11.757 17.3916 12.017C17.4772 12.2898 17.5197 12.5744 17.5175 12.8603C17.5176 13.1348 17.4708 13.4073 17.379 13.6659C17.2895 13.9099 17.1712 14.1423 17.0266 14.3582C16.8898 14.5699 16.7384 14.7718 16.5734 14.9624L16.1203 15.5163C15.9891 15.6786 15.8713 15.8511 15.7678 16.0323C15.6811 16.1954 15.6336 16.3764 15.6294 16.561L15.6294 17.1778L14.1189 17.1778L14.1189 16.347C14.1145 16.1306 14.1574 15.9158 14.2448 15.7177C14.3363 15.5167 14.4504 15.3266 14.5846 15.1512C14.7231 14.975 14.8741 14.7988 15.0252 14.6351L15.4657 14.1065C15.6002 13.9267 15.7142 13.7325 15.8056 13.5275C15.8975 13.3298 15.9441 13.1158 15.9441 12.8981C15.9458 12.7683 15.9201 12.6396 15.8685 12.5205C15.8235 12.4139 15.7546 12.3192 15.6671 12.2435C15.5879 12.1664 15.4936 12.1064 15.3902 12.0673C15.2776 12.0494 15.1629 12.0494 15.0503 12.0673C14.9198 12.06 14.7893 12.0811 14.6677 12.129C14.4842 12.2083 14.327 12.3381 14.2143 12.5032C14.1015 12.6683 14.0379 12.8619 14.0308 13.0617L12.4825 13.0617C12.508 12.753 12.5715 12.4486 12.6713 12.1554C12.7787 11.8668 12.9412 11.6017 13.1496 11.375C13.3636 11.1283 13.6292 10.9344 13.9301 10.8086C14.2803 10.6606 14.6576 10.5877 15.0378 10.5946C15.4294 10.5818 15.8194 10.6503 16.1832 10.796ZM15.5916 17.933L14.1189 17.933L14.1189 19.4058L15.5916 19.4058L15.5916 17.933Z",
    fill: "#6E74FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_385_634",
    x: 0,
    y: 0,
    width: 33,
    height: 33,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "effect1_foregroundBlur_385_634"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_385_634"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(9.00027 21.0005) rotate(-90)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.57341015e9d6e5382fb26d3cf7b05ebf.svg";
export { ForwardRef as ReactComponent };